import { combineReducers } from "redux";

import ajaxCounter from "./ajaxCounterReducer";

import errorMessage from "./errorReducer";
import settings from "./settingReducer";
import layout from "./layoutReducer";
import exception from "./exceptionReducer";

import referentie from "./referentieReducer";
import infrastructuren from "./infrastructuurReducer";

import aanvraag from "./aanvraagReducer";
import project from "./projectReducer";
import mijnDossier from "./mijnDossierReducer";
import simulatieDossier from "./simulatieDossierReducer";
import schaduwDossier from "./schaduwDossierReducer";
import minimaleEisenPerDossier from "./minimaleEisenPerDossierReducer";
import minimaleEisenPerInfrastructuur from "./minimaleEisenPerInfrastructuurReducer";
import bovenLokaliteitPerDossier from "./bovenLokaliteitPerDossierReducer";
import bovenLokaliteitPerInfrastructuur from "./bovenLokaliteitPerInfrastructuurReducer";
import beoordelingscriteria from "./criteriaReducer";
import indienen from "./indienenReducer";
import { beadReducer as beads, voortgangsrapportBeadReducer as voortgangsrapportBeads } from "./beadReducer";
import simulatiePerInfrastructuurModal from "./simulatiePerInfrastructuurReducer";

import voortgangsrapportLoaded from "./voortgangsrapportReducer";

// alle reducers hier importeren

const rootReducer = combineReducers({
	// alle reducers hier in opnemen
	ajaxCounter, // contains info used by the loader
	errorMessage,
	settings, // contains config style values, rootPath, ApiUrls, ... that are NOT user specific. No Application/Component states here.
	// session, // contains information that is specific to the users' session and his interaction with the application, accountId, loading, info about available tabs, the opened tab, ...
	layout, // contains info about the layout state of the application
	referentie,
	aanvraag,
	exception,
	infrastructuren,
	project,
	mijnDossier,
	schaduwDossier,
	minimaleEisenPerDossier,
	minimaleEisenPerInfrastructuur,
	bovenLokaliteitPerDossier,
	bovenLokaliteitPerInfrastructuur,
	simulatiePerInfrastructuurModal,
	beoordelingscriteria,
	indienen,
	beads,
	voortgangsrapportBeads,
	voortgangsrapportLoaded,
	simulatieDossier
});

export default rootReducer;
